import React, { Component } from 'react'
import Dialog from '@material-ui/core/Dialog'
import {
  DatePicker as MuiDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers'
import DateFnsUtils from '@date-io/moment'
import moment from 'moment'
import LOG from '../logging/Logger'

class DatePicker extends Component {
  state = {
    date: moment().add(1, 'days')
  }

  render() {
    LOG.debug('Render: DatePicker')

    const { open, portrait, onSave, onClose } = this.props,
      { date } = this.state

    return (
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Dialog open={open} onClose={onClose}>
          <MuiDatePicker
            orientation={portrait ? 'portrait' : 'landscape'}
            variant='static'
            disablePast={true}
            shouldDisableDate={checkDate => moment().isSame(checkDate, 'day')}
            openTo='date'
            value={date}
            onChange={newDate => {
              onSave(newDate)
            }}
          />
        </Dialog>
      </MuiPickersUtilsProvider>
    )
  }
}

export default DatePicker
